export default __webpack_public_path__ + "images/40c5ce3efcd3e83fa8585178b850a580.svg";